export default __webpack_public_path__ + "static/media/zip.3cd875e1.svg";